module.exports = __webpack_public_path__ + "static/uxgorilla-1e721a7da4847e3e60e5e2f9e3a534c1.png";